import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About Me</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>Hey there! I'm a Data Engineer Fellow at Insight Data Science. I'm a Master's graduate in Data Analytics at Northeastern University. I live in Boston. I've 2+ years of industry experience in the field of Data Science. I'm currently looking for full-time opportunities in the areas of Data Engineering and Machine Learning.</p>
                    <p>I like to collect data and making it talk when asked right questions. Most of my work includes orchestrating the data pipelines and build scalable machine learning models. I love challenges that push me out of my comfort zone constantly and help me get a better understanding of the work I do.</p>
                    <p>I love travelling and playing cricket. I'm a huge fan of M.S Dhoni. If you need anything from me, you know where to start :)</p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Machine Learning</h3>
                    <p>Experienced in building scalable Machine Learning models using PYTHON and R. </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Data Structures & Algorithms</h3>
                    <p>Well versed with the fundamental concepts of DSA.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Big Data</h3>
                    <p>Familar with Big Data architecture for building distributed software platforms like <b>Apache Hadoop</b> and <b>Spark</b>. Utilized various open source technologies and cloud services to process the data efficiently and orchestrate pipelines.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Data Analytics</h3>
                    <p>Well versed with <b>Probability</b> and <b>Statistical</b> knowledge using Python and R as my goto tools to carry out data analysis on large datasets.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Cloud Technologies</h3>
                    <p>Heavily used <b>AWS</b> platform to deploy data pipelines in cloud. Also, have some basic knowledge of <b>GCP</b> and it services in the data engineering space.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Data Vizualization</h3>
                    <p>Used <b>Tableau</b> for most of my projects and <b>Python Dash (Plotly)</b> along with matplotlib and Rshiny.</p>
                </div>
                </div>
            </div>
            {/*
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
        </div>
        
        </section>
        
    
        
      </div>
    )
  }
}
